"use client"

import { useQuery } from "@tanstack/react-query"
import type { ReferralCodeWithStats } from "@/lib/referral-types"

export const REFERRAL_DASHBOARD_KEY = ["referral-dashboard"] as const

export const useReferralDashboard = () => {
  return useQuery<ReferralCodeWithStats[]>({
    queryKey: REFERRAL_DASHBOARD_KEY,
    queryFn: async () => {
      const res = await fetch("/api/referral/dashboard")
      if (!res.ok) throw new Error("Failed to fetch referral dashboard")
      return res.json()
    },
    refetchInterval: 30_000,
  })
}
